/**
 * <inquiry-opener>
 *
 * Wraps the INQUIRE button on each trunk-show card. When clicked, it stamps
 * the trunk show's Klaviyo list_id and per-show show_identifier onto the
 * shared inquiry form before Prestige's native aria-controls plumbing opens
 * the #ModalDrawer-InquiryForm drawer.
 *
 * Required data attributes (set in trunk-show-card.liquid):
 *   data-list-id           — the Klaviyo list ID for this trunk show
 *   data-show-identifier   — the show identifier (routes to the right Klaviyo segment)
 *
 * Required inner markup:
 *   <button aria-controls="ModalDrawer-InquiryForm">…</button>
 */
if (!customElements.get('inquiry-opener')) {
  class InquiryOpener extends HTMLElement {
    constructor() {
      super();
      this.list = this.dataset.listId || '';
      this.showIdentifier = this.dataset.showIdentifier || '';
      this.handleClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    onClick(event) {
      const trigger = event.target.closest('button, a');
      if (!trigger || !this.contains(trigger)) return;

      // Target the modal-form id; the inline empty-state form uses a different id.
      const form = document.querySelector('#InquiryForm');
      if (!form) return;

      const listInput = form.querySelector('[data-list-id-input]');
      const showInput = form.querySelector('[data-show-identifier-input]');

      if (listInput) listInput.value = this.list;
      if (showInput) showInput.value = this.showIdentifier;
    }
  }

  customElements.define('inquiry-opener', InquiryOpener);
}
